<div mat-dialog-content>
    <div class="apps-container-button">
        <button mat-icon-button (click)="close()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <p class="title">Listado de Modulos</p>
    <div class="section-container-option">
        <select class="form-control" [(ngModel)]="sectionId" (change)="search()">
            <option value="0" disabled>Selecciona una seccion</option>
            <option *ngFor="let s of sectionList" value="{{s.id}}">{{s.name}}</option>
        </select>
    </div>
    <table class="apps-table" mat-table [dataSource]="dataSource" #table>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let item">{{item.name}}</td>
        </ng-container>
        <ng-container matColumnDef="asignar">
            <th mat-header-cell *matHeaderCellDef>Asignar</th>
            <td mat-cell *matCellDef="let item">
                <div class="apps-container-checkbox" matRipple [matRippleCentered]="true" [matRippleRadius]="40">
                    <div class="apps-checkbox">
                        <input [id]="item.id" type="checkbox" [checked]="item.active" (click)="checked($event.srcElement,item.id)">
                        <label class="apps-label" [for]="item.id">
                            <mat-icon>done</mat-icon>
                        </label>
                    </div>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
</div>